import { createApi } from '@reduxjs/toolkit/query/react';
import { httpBaseQuery } from './httpBaseQuery';

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: httpBaseQuery(),
    endpoints: () => ({}),
    tagTypes: [],
});
